import { render } from "./SimpleMap.vue?vue&type=template&id=4ef0e0fb&scoped=true"
import script from "./SimpleMap.vue?vue&type=script&lang=js"
export * from "./SimpleMap.vue?vue&type=script&lang=js"

import "./SimpleMap.vue?vue&type=style&index=0&id=4ef0e0fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef0e0fb"]])

export default __exports__